import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { CategoryIcon } from '../components/Icons';
import { useSeo, seoUrl } from '../lib/seo';

export default function Categories() {
  useSeo({
    title: 'Kategori Produk',
    description: 'Telusuri kategori produk digital konstruksi: gambar kerja, RAB & AHSP, dokumen tender, struktur, MEP, dan lainnya.',
    canonical: seoUrl('/kategori'),
  });
  const [categories, setCategories] = useState(null);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    // Error sementara ≠ daftar kosong (anti Soft 404)
    api.get('/categories').then((r) => setCategories(r.data)).catch(() => setLoadError(true));
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="categories-page">
      <Header />
      <div className="bg-zinc-50 border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
          <p className="text-brand-red text-xs font-semibold tracking-[0.25em] uppercase mb-2">Jelajahi</p>
          <h1 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight">Semua Kategori</h1>
          <p className="text-sm text-zinc-500 mt-3 max-w-xl">Temukan produk digital berdasarkan kebutuhan proyek Anda — dari gambar kerja hingga modul pelatihan.</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        {loadError ? (
          <div className="border border-dashed border-border p-16 text-center" data-testid="categories-load-error">
            <p className="font-heading font-bold text-lg">Kategori sedang tidak dapat dimuat</p>
            <p className="text-sm text-zinc-500 mt-2">Periksa koneksi Anda, lalu muat ulang halaman.</p>
          </div>
        ) : !categories ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">{[...Array(6)].map((_, i) => <div key={i} className="h-40 border border-border animate-pulse bg-zinc-50" />)}</div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {categories.map((c, i) => (
              <div key={c.category_id} className="border border-border p-6 hover:border-brand-black transition-colors animate-fade-in" style={{ animationDelay: `${i * 40}ms` }} data-testid={`category-block-${c.slug}`}>
                <Link to={`/kategori/${c.slug}`} className="flex items-center gap-4 group">
                  <div className="w-12 h-12 bg-zinc-100 group-hover:bg-brand-red group-hover:text-white text-zinc-700 flex items-center justify-center transition-colors">
                    <CategoryIcon name={c.icon} className="w-5 h-5" />
                  </div>
                  <h2 className="font-heading font-bold text-lg group-hover:text-brand-red transition-colors">{c.name}</h2>
                </Link>
                <div className="flex flex-wrap gap-2 mt-5">
                  {c.subcategories?.map((s) => (
                    <Link key={s.sub_id} to={`/produk?category=${c.category_id}&subcategory=${s.sub_id}`} data-testid={`subcat-${s.slug}`}
                      className="text-xs border border-border px-2.5 py-1 text-zinc-600 hover:border-brand-black hover:text-brand-black transition-colors">
                      {s.name}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
